// material-ui
import { LoadingButton } from '@mui/lab';
import { Alert, Button, FormHelperText, Skeleton, Stack, Table, TableBody, TableCell, TableRow, TextField } from '@mui/material';
import Pagination from 'components/@extended/Pagination';
// project import
import MainCard from 'components/MainCard';
import React from 'react';
import { deleteRequest, getRequest, postRequest } from 'utils/apiRequest';

import { Box } from '@mui/system';
import { Formik } from 'formik';
import * as Yup from 'yup';

import CsvUploader from 'components/Uploaders/CsvUploader';
import { isShopifyApp } from 'context/UserAuthContext';
import { ProductEditModal } from './modals/ProductEditModal';
import { Notice } from 'components/Notice';
import Image from 'components/Image';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const storedUser = localStorage.getItem('user');
let user = {};
if (storedUser) {
    user = JSON.parse(storedUser);
}

// ==============================|| SAMPLE PAGE ||============================== //

const ProductSchema = Yup.object().shape({
    name: Yup.string().max(75).required('Warehouse is required'),
    sku: Yup.string().max(50).required('SKU is required'),
    category: Yup.string().max(50),
    description: Yup.string().max(255),
    upc: Yup.string().max(15),
    image_url: Yup.string().max(100),
})

const AddNewProduct = ({ onSuccess = () => { } }) => {
    const [products, setProducts] = React.useState([]);
    const [success, setSuccess] = React.useState(false);
    const [product, setProduct] = React.useState({
        name: '',
        sku: '',
        category: '',
        description: '',
        upc: '',
        image_url: '',
    })

    const loadFakeProduct = () => {
        getRequest('/account/product/fake').then(d => {
            setProduct(d);
        })
    }
    return <Formik
        initialValues={product}
        validationSchema={ProductSchema}
        enableReinitialize={true}
        onSubmit={(values, { setErrors, setStatus, setSubmitting }) => {
            setSuccess(false);
            setSubmitting(true);
            let formData = new FormData();
            Object.keys(values).forEach((k) => {
                formData.append(k, values[k]);
            })
            postRequest('/account/product/create', formData).then(d => {
                if (d.errors) {
                    const err = {}
                    Object.keys(d.errors).forEach((k) => {
                        err[k] = d.errors[k][0];
                    })
                    setErrors(err);
                } else {
                    setSuccess(true);
                    onSuccess(d);
                }
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                setSubmitting(false);
            })
        }}>
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form noValidate onSubmit={handleSubmit}>
                {success && (
                    <Alert severity="success">Product added</Alert>
                )}
                <MainCard title="Add Product" secondary={<Stack direction="row"><CsvUploader buttonText="Upload CSV" type="products" />{user.account_id === 1 ? (<Button onClick={() => loadFakeProduct()}>Fake Product</Button>) : <></>}</Stack>}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Product Name</TableCell>
                                <TableCell>
                                    <TextField name="name" type="text" value={values.name} onChange={handleChange} autoComplete="warehouse-name" />
                                    {touched.name && errors.name && (
                                        <FormHelperText error>
                                            {errors.name}
                                        </FormHelperText>
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Product SKU</TableCell>
                                <TableCell>
                                    <TextField name="sku" type="text" value={values.sku} onChange={handleChange} />
                                    {touched.sku && errors.sku && (
                                        <FormHelperText error>
                                            {errors.sku}
                                        </FormHelperText>
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Product Category</TableCell>
                                <TableCell>
                                    <TextField name="category" type="text" value={values.category} onChange={handleChange} />
                                    {touched.category && errors.category && (
                                        <FormHelperText error>
                                            {errors.category}
                                        </FormHelperText>
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Product Description</TableCell>
                                <TableCell>
                                    <TextField name="description" type="text" value={values.description} onChange={handleChange} />
                                    {touched.description && errors.description && (
                                        <FormHelperText error>
                                            {errors.description}
                                        </FormHelperText>
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Product UPC</TableCell>
                                <TableCell>
                                    <TextField name="upc" type="text" value={values.upc} onChange={handleChange} />
                                    {touched.upc && errors.upc && (
                                        <FormHelperText error>
                                            {errors.upc}
                                        </FormHelperText>
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Product Image URL</TableCell>
                                <TableCell>
                                    <TextField name="image_url" type="text" value={values.image_url} onChange={handleChange} />
                                    {touched.image_url && errors.image_url && (
                                        <FormHelperText error>
                                            {errors.image_url}
                                        </FormHelperText>
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <LoadingButton
                        disableElevation
                        disabled={isSubmitting}
                        size="large"
                        type="submit"
                        variant="contained"
                        color="primary"
                        loading={isSubmitting}
                    >
                        Submit
                    </LoadingButton>
                </MainCard>
            </form>
        )}
    </Formik>
}

const ProductsLoading = () => {
    return <>{[...Array(5)].map((n, i) => {
        return (<TableRow key={i}>
            <TableCell sx={{ width: 95 }}>
                <Skeleton variant="rectangular" width={75} height={75} />
            </TableCell>
            <TableCell>
                <Skeleton variant="text" width={"70%"} />
                <Skeleton variant="text" width={"50%"} />
                <Skeleton variant="text" width={"40%"} />
                <Skeleton variant="text" width={"30%"} />
            </TableCell>
        </TableRow>)
    })}</>
}

const Products = () => {
    const [accountProducts, setAccountProducts] = React.useState([]);
    const [addProducts, setAddProducts] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [product, setProduct] = React.useState({});
    const [allWarehouses, setAllWarehouses] = React.useState([]);
    const [allCarriers, setAllCarriers] = React.useState([]);
    const [pagination, setPagination] = React.useState({
        current: 1,
        total: 1,
    });


    const setPage = (p) => {
        getProducts(p);
    };
    React.useEffect(() => {
        setLoading(true);
        getProducts();
        getWarehouses();
        getCarriers();
    }, []);
    const getWarehouses = () => {
        getRequest('/account/warehouses').then((d) => {
            setAllWarehouses(d);
        })
    }
    const getProducts = (page = 1) => {
        getRequest('/account/products?page=' + page).then((d) => {
            if(d && d.data){
                setAccountProducts(d.data);
                setPagination({
                    current: d.current_page,
                    total: d.last_page,
                })
            }
        }).finally(() => {
            setLoading(false);
        })
    }
    const getCarriers = () => {
        return getRequest('/carriers').then((d) => {
            if (d) {
                setAllCarriers(d);
            }
        })
    }
    // const getWarehouseCarrierInfo = () => {
    //     return new Promise((resolve, reject) => {
    //         let c = {};
    //         getRequest('/account/warehouse/carriers').then(d => {
    //             d.forEach((awc, i) => {
    //                 if (c[awc.warehouse.id] === undefined) {
    //                     c[awc.warehouse.id] = [];
    //                 }
    //                 c[awc.warehouse.id].push(awc);
    //             })
    //             setAllCarriers(c);
    //             resolve(d)
    //         });
    //     })
    // }
    const handleDeleteProduct = (productId) => {
        var result = window.confirm("Are you sure you want to delete this?");
        if (result === true) {
            deleteRequest('/account/product/delete/' + productId).then(data => {
                getProducts();
            })
        }
    }
    return (<>{addProducts ? (
        <AddNewProduct onSuccess={(d) => {
            getProducts();
            setAddProducts(false)
        }} />
    ) : (<>
        <MainCard title="Products" secondary={isShopifyApp() ? <></> : <Button onClick={() => setAddProducts(true)} variant="outlined">Add Product</Button>}>
            {loading || accountProducts.length > 0 ? (
                <>
                    <Table>
                        <TableBody>
                            {loading ? (
                                <ProductsLoading />
                            ) : (<>
                                {accountProducts.map((p, i) => {
                                    return (p.name ? (<TableRow key={i}>
                                        <TableCell sx={{ width: 95 }}>
                                            <Image 
                                                src={p.image_url} 
                                                alt={p.name} 
                                                width={45} 
                                                height={45} />
                                        </TableCell>
                                        <TableCell>
                                            {p.name}<br />
                                            {p.sku && (<><strong>ID:</strong> {p.sku}<br /></>)}
                                            {p.average_estimated_delivery_days && (<><strong>Average Days To Delivery:</strong> {p.average_estimated_delivery_days}<br /></>)}
                                            {/* {p.category && (<><strong>category:</strong> {p.category}<br /></>)}
                                    {p.upc && (<><strong>upc:</strong> {p.upc}<br /></>)} */}
                                        </TableCell>
                                        <TableCell align="right" width={40}>
                                            <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr' }}>
                                                <ProductEditModal
                                                    product={p}
                                                    warehouses={allWarehouses}
                                                    carriers={allCarriers} />
                                            </Box>
                                        </TableCell>
                                    </TableRow>) : null
                                    )
                                })}</>)}
                        </TableBody>
                    </Table>
                    <Pagination
                        count={pagination.total}
                        page={pagination.current}
                        setPage={(p) => setPage(p)}
                    />
                </>) : (
                <Notice>No products. Products will populate as users view the Estimated Delivery Date componenent on your website. If you have not integrated with your website, view our <a href={process.env.REACT_APP_DOCS_URL} target="_blank">documentation</a> to get started.</Notice>
            )}
        </MainCard>

    </>)}</>);
}


export default Products;
